/* LOTE C (02/11/2026): código em uso de snippets/custom-code-upsell.liquid ("Garanta o frete grátis" / "Aproveite e leve também").
   O <script> que continua dentro do snippet NÃO vai mais para a página: layout/theme.liquid usa só o estilo do snippet e
   passa os dados da loja (estoque de shorts/camisetas/polos, bonés, se é a página /cart) em window.__srfUP.
   Alterações no JS: editar ESTE arquivo. */
  (function() {
    var FREE_SHIP = 29900; /* frete grátis a partir de R$ 299 (centavos) */
    var TITLE_NO_SHIP = 'Garanta o frete grátis', TITLE_SHIP_OK = 'Aproveite e leve também';
    var SIZE_ORDER = ['PP', 'P', 'M', 'G', 'GG', 'EXG', 'XG1', 'XGG', 'XG', 'G1', 'G2', 'G3', 'UNI', 'U'];
    var TXT_OPEN = 'Tamanhos', TXT_CLOSE = 'Fechar';
    var UPD = window.__srfUP || {};
    var IS_CART_PAGE = !!UPD.cart;
    /* alto estoque: [handle, categoria, estoque] de shorts/camisetas/polos (adultos); bonés: handles da coleção bones */
    var STOCK = UPD.stock || [];
    var CAPS = {};
    (UPD.caps || []).forEach(function(h) { CAPS[h] = 1; });
    var CAT = {};
    STOCK.forEach(function(s) { CAT[s[0]] = s[1]; });
    STOCK.sort(function(a, b) { return b[2] - a[2]; });
    var recCache = {}, prodCache = {}, hCache = {}, state = { drawer: { key: null, loading: false }, page: { key: null, loading: false } };
    function money(c) { return 'R$ ' + (c / 100).toFixed(2).replace('.', ','); }
    function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function(c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
    function img(u) { if (!u) return ''; u = u.indexOf('//') === 0 ? 'https:' + u : u; return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=160'; }
    function vImg(v, p) { return (v && v.featured_image && v.featured_image.src) || p.featured_image || ''; }
    function optName(o) { return typeof o === 'string' ? o : (o && o.name) || ''; }
    function isSize(name) { return /tamanho|size|numera/i.test(name); }
    /* valor que conta para o frete grátis: preço cheio (antes dos kits) menos cupons — mesmo critério da Frenet */
    function shipBase(cart) {
      var lvl = (cart.cart_level_discount_applications || []).reduce(function(a, d) { return a + (d.total_allocated_amount || 0); }, 0);
      return Math.max((cart.original_total_price || 0) - lvl, cart.total_price || 0);
    }
    function sizeRank(s) {
      var t = String(s).trim().toUpperCase();
      var n = parseFloat(t.replace(',', '.'));
      if (!isNaN(n) && /^\d/.test(t)) return 1000 + n;
      var i = SIZE_ORDER.indexOf(t);
      return i >= 0 ? i : 500;
    }
    function card(p, missing) {
      var av = (p.variants || []).filter(function(v) { return v.available; });
      if (!av.length) return '';
      prodCache[p.id] = p;
      var opts = p.options || [], varying = [];
      for (var i = 0; i < opts.length; i++) {
        var seen = {};
        for (var j = 0; j < av.length; j++) seen[(av[j].options || [])[i]] = 1;
        if (Object.keys(seen).length > 1) varying.push(i);
      }
      var url = (p.url || ('/products/' + p.handle)).split('?')[0];
      var first = av[0], act = '', panel = '';
      var sizeIdx = -1;
      for (var s = 0; s < varying.length; s++) { if (isSize(optName(opts[varying[s]]))) sizeIdx = varying[s]; }
      if (varying.length === 0) {
        act = '<button type="button" class="srf-upsell__btn" data-srf-add data-v="' + first.id + '">Adicionar</button>';
      } else if (varying.length === 1 && sizeIdx < 0 && av.length <= 8) {
        var k = varying[0], nm = optName(opts[k]) || 'opção';
        var sel = '<span class="srf-upsell__hint">Escolha a ' + esc(nm.toLowerCase()) + '</span>' +
          '<select class="srf-upsell__sel" data-srf-simple aria-label="Escolha a ' + esc(nm.toLowerCase()) + '">';
        for (var m = 0; m < av.length; m++) sel += '<option value="' + av[m].id + '" data-img="' + esc(img(vImg(av[m], p))) + '">' + esc((av[m].options || [])[k]) + '</option>';
        sel += '</select>';
        act = sel + '<button type="button" class="srf-upsell__btn" data-srf-add>Adicionar</button>';
      } else if (sizeIdx >= 0 && varying.length <= 2) {
        act = '<button type="button" class="srf-upsell__btn srf-upsell__btn--ghost" data-srf-open aria-expanded="false" aria-label="Escolher tamanho">' + TXT_OPEN + '</button>';
        panel = '<div class="srf-upsell__panel" data-size-idx="' + sizeIdx + '" data-color-idx="' + (varying.length === 2 ? (varying[0] === sizeIdx ? varying[1] : varying[0]) : -1) + '"></div>';
      } else {
        act = '<a class="srf-upsell__btn srf-upsell__btn--ghost" href="' + esc(url) + '">Ver opções</a>';
      }
      var price = first.price != null ? first.price : p.price;
      var ship = (missing > 0 && price >= missing) ? '<div class="srf-upsell__ship">✓ Garante frete grátis</div>' : '';
      return '<div class="srf-upsell__item" data-pid="' + p.id + '"><div class="srf-upsell__row">' +
        '<a href="' + esc(url) + '"><img class="srf-upsell__img" src="' + esc(img(vImg(first, p))) + '" alt="' + esc(p.title) + '" loading="lazy"></a>' +
        '<div class="srf-upsell__info"><a class="srf-upsell__name" href="' + esc(url) + '">' + esc(p.title) + '</a>' +
        '<div class="srf-upsell__price">' + money(price) + '</div>' + ship + '</div>' +
        '<div class="srf-upsell__act">' + act + '</div></div>' + panel + '</div>';
    }
    /* monta o painel compacto de tamanho (e cor) dentro do card */
    function buildPanel(item) {
      var p = prodCache[item.getAttribute('data-pid')];
      var panel = item.querySelector('.srf-upsell__panel');
      if (!p || !panel) return;
      var sIdx = +panel.getAttribute('data-size-idx'), cIdx = +panel.getAttribute('data-color-idx');
      var opts = p.options || [], all = p.variants || [];
      var colors = [];
      if (cIdx >= 0) all.forEach(function(v) { var c = (v.options || [])[cIdx]; if (c && colors.indexOf(c) < 0 && all.some(function(x) { return x.available && (x.options || [])[cIdx] === c; })) colors.push(c); });
      var color = panel.getAttribute('data-color') || colors[0] || null;
      var sizes = [];
      all.forEach(function(v) { var sz = (v.options || [])[sIdx]; if (sz && sizes.indexOf(sz) < 0) sizes.push(sz); });
      sizes.sort(function(a, b) { return sizeRank(a) - sizeRank(b); });
      var chosen = panel.getAttribute('data-size') || '';
      var html = '<div class="srf-upsell__sizes" role="group" aria-label="' + esc(optName(opts[sIdx]) || 'Tamanho') + '">';
      var chosenOk = false;
      sizes.forEach(function(sz) {
        var v = all.filter(function(x) { return (x.options || [])[sIdx] === sz && (cIdx < 0 || (x.options || [])[cIdx] === color); })[0];
        var ok = v && v.available;
        if (ok && sz === chosen) chosenOk = true;
        html += '<button type="button" class="srf-upsell__size' + (ok && sz === chosen ? ' is-active' : '') + '" data-srf-size="' + esc(sz) + '"' + (ok ? '' : ' disabled') + '>' + esc(sz) + '</button>';
      });
      html += '</div><div class="srf-upsell__prow">';
      if (colors.length > 1) {
        html += '<select class="srf-upsell__sel" data-srf-color aria-label="' + esc(optName(opts[cIdx]) || 'Cor') + '">';
        colors.forEach(function(c) { html += '<option' + (c === color ? ' selected' : '') + '>' + esc(c) + '</option>'; });
        html += '</select>';
      }
      html += '<button type="button" class="srf-upsell__btn" data-srf-add-panel' + (chosenOk ? '' : ' disabled') + '>' + (chosenOk ? 'Adicionar' : 'Escolha o tamanho') + '</button></div>';
      panel.innerHTML = html;
      if (!chosenOk) panel.removeAttribute('data-size');
      if (color && cIdx >= 0) {
        var cv = all.filter(function(x) { return (x.options || [])[cIdx] === color; })[0];
        var im = item.querySelector('.srf-upsell__img');
        if (cv && im) im.src = img(vImg(cv, p));
      }
    }
    function selectedVariant(item) {
      var p = prodCache[item.getAttribute('data-pid')], panel = item.querySelector('.srf-upsell__panel');
      if (!p || !panel) return null;
      var sIdx = +panel.getAttribute('data-size-idx'), cIdx = +panel.getAttribute('data-color-idx');
      var size = panel.getAttribute('data-size'), sel = panel.querySelector('[data-srf-color]');
      var color = sel ? sel.value : (panel.getAttribute('data-color') || null);
      return (p.variants || []).filter(function(x) {
        return x.available && (x.options || [])[sIdx] === size && (cIdx < 0 || !color || (x.options || [])[cIdx] === color);
      })[0] || null;
    }
    function getRecs(pid) {
      if (recCache[pid]) return Promise.resolve(recCache[pid]);
      return fetch('/recommendations/products.json?product_id=' + pid + '&limit=10&intent=related')
        .then(function(r) { return r.json(); })
        .then(function(d) { recCache[pid] = (d && d.products) || []; return recCache[pid]; })
        .catch(function() { return []; });
    }
    function getProdH(h) {
      if (hCache[h]) return Promise.resolve(hCache[h]);
      return fetch('/products/' + h + '.js', { credentials: 'same-origin' }).then(function(r) { return r.ok ? r.json() : null; })
        .then(function(p) { hCache[h] = p; return p; }).catch(function() { return null; });
    }
    /* itens de alto estoque: categoria diferente das do carrinho, um por categoria; se não houver, qualquer categoria */
    function pickStock(inCartH, cartCats, n) {
      var out = [], usedCat = {}, i, s;
      for (i = 0; i < STOCK.length && out.length < n; i++) {
        s = STOCK[i];
        if (s[2] <= 0 || inCartH[s[0]] || cartCats[s[1]] || usedCat[s[1]]) continue;
        out.push(s[0]); usedCat[s[1]] = 1;
      }
      for (i = 0; i < STOCK.length && out.length < n; i++) {
        s = STOCK[i];
        if (s[2] <= 0 || inCartH[s[0]] || out.indexOf(s[0]) > -1) continue;
        out.push(s[0]);
      }
      return out;
    }
    /* ctx: 'drawer' (gaveta) ou 'page' (/cart) */
    function renderIn(ctx) {
      var st = state[ctx];
      if (st.loading) return;
      var items, box, table = null, dr = null;
      if (ctx === 'drawer') {
        dr = document.getElementById('cart-drawer-container');
        if (!dr) return;
        items = dr.querySelector('.scd__items'); box = dr.querySelector('.srf-upsell');
      } else {
        table = document.querySelector('.sf-cart__table');
        if (!table) return;
        items = table.querySelector('.scd__items'); box = document.querySelector('.srf-upsell--page');
      }
      if (!items || !items.children.length) { if (box) box.remove(); st.key = null; return; }
      var key = items.children.length + '|' + items.textContent.replace(/\s+/g, '').length;
      if (key === st.key && box) return;
      if (box && box.querySelector('.srf-upsell__item.is-open')) return; /* não redesenha enquanto o cliente escolhe */
      st.loading = true;
      var max = ctx === 'page' ? 4 : 2, nStock = ctx === 'page' ? 2 : 1;
      fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        if (!cart.items || !cart.items.length) { st.loading = false; return; }
        var inCart = {}, inCartH = {}, cartCats = {}, hasBuy = false, hasCap = false;
        cart.items.forEach(function(i) {
          inCart[i.product_id] = 1; inCartH[i.handle] = 1;
          if (CAT[i.handle]) { cartCats[CAT[i.handle]] = 1; hasBuy = true; }
          if (CAPS[i.handle]) hasCap = true;
        });
        var dealOn = hasBuy && !hasCap; /* "Compre junto" na tela: boné já oferecido acima */
        var missing = FREE_SHIP - shipBase(cart);
        var title = missing > 0 ? TITLE_NO_SHIP : TITLE_SHIP_OK;
        var stockH = pickStock(inCartH, cartCats, max); /* os nStock primeiros vão antes; o resto completa no fim */
        return Promise.all([getRecs(cart.items[0].product_id), Promise.all(stockH.map(getProdH))]).then(function(res) {
          var recs = res[0], stockP = res[1], html = '', n = 0, shown = {};
          stockP.slice(0, nStock).forEach(function(p) {
            if (!p || n >= max || inCart[p.id] || shown[p.handle]) return;
            var c = card(p, missing);
            if (c) { html += c; n++; shown[p.handle] = 1; }
          });
          for (var i = 0; i < recs.length && n < max; i++) {
            var r = recs[i];
            if (inCart[r.id] || shown[r.handle]) continue;
            if ((dealOn || (hasBuy && hasCap)) && (CAPS[r.handle] || /bon[eé]/i.test(r.title || ''))) continue; /* inclui bonés fora da coleção bones (ex.: infantis) */
            var c2 = card(r, missing);
            if (c2) { html += c2; n++; shown[r.handle] = 1; }
          }
          stockP.slice(nStock).forEach(function(p) {
            if (!p || n >= max || inCart[p.id] || shown[p.handle]) return;
            var c3 = card(p, missing);
            if (c3) { html += c3; n++; shown[p.handle] = 1; }
          });
          if (!n) { if (box) box.remove(); }
          else {
            if (!box) { box = document.createElement('div'); box.className = 'srf-upsell' + (ctx === 'page' ? ' srf-upsell--page' : ''); }
            box.innerHTML = '<p class="srf-upsell__title">' + title + '</p><div class="srf-upsell__list">' + html + '</div>';
            if (ctx === 'page') {
              if (box.parentNode !== table) table.appendChild(box);
            } else {
              var itemsNow = dr.querySelector('.scd__items');
              if (itemsNow && !box.parentNode) itemsNow.parentNode.insertBefore(box, itemsNow.nextSibling);
            }
          }
          st.key = items.isConnected ? items.children.length + '|' + items.textContent.replace(/\s+/g, '').length : null;
          st.loading = false;
        });
      }).catch(function() { st.loading = false; });
    }
    function refreshDrawer() {
      var C = window.spratlyTheme && window.spratlyTheme.Cart;
      if (!C) return Promise.resolve();
      try { if (typeof C.refreshCart === 'function') C.refreshCart(); } catch (e) {}
      var p1 = (typeof C.fetchCartSection === 'function' && typeof C.renderNewCart === 'function')
        ? Promise.resolve(C.fetchCartSection()).then(function(node) { if (node) return C.renderNewCart(node); }).catch(function() {})
        : Promise.resolve();
      var p2 = fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        try { if (typeof C.updateCartCount === 'function') C.updateCartCount(cart); } catch (e) {}
      }).catch(function() {});
      return Promise.all([p1, p2]);
    }
    function addVariant(id, b) {
      if (!id) return;
      var onPage = !!b.closest('.srf-upsell--page');
      b.disabled = true; b.textContent = 'Adicionando…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }) })
        .then(function(r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function() {
          if (onPage) { window.location.reload(); return; }
          var open = document.querySelector('#cart-drawer-container .srf-upsell__item.is-open');
          if (open) open.classList.remove('is-open');
          state.drawer.key = null;
          return refreshDrawer().then(function() { setTimeout(function() { renderIn('drawer'); }, 400); });
        })
        .catch(function() { b.disabled = false; b.textContent = 'Adicionar'; });
    }
    /* trocas de seleção */
    document.addEventListener('change', function(e) {
      var s = e.target;
      if (!s.classList || !s.classList.contains('srf-upsell__sel')) return;
      var item = s.closest('.srf-upsell__item');
      if (!item || !item.closest('.srf-upsell')) return;
      if (s.hasAttribute('data-srf-color')) {
        var panel = item.querySelector('.srf-upsell__panel');
        panel.setAttribute('data-color', s.value);
        buildPanel(item);
        return;
      }
      var o = s.options[s.selectedIndex], im = item.querySelector('.srf-upsell__img');
      if (o && im && o.getAttribute('data-img')) im.src = o.getAttribute('data-img');
    });
    document.addEventListener('click', function(e) {
      var t = e.target.closest && e.target.closest('[data-srf-open],[data-srf-size],[data-srf-add],[data-srf-add-panel]');
      if (!t || !t.closest('.srf-upsell')) return;
      e.preventDefault();
      var item = t.closest('.srf-upsell__item');
      var scope = t.closest('.srf-upsell');
      if (t.hasAttribute('data-srf-open')) {
        var others = scope.querySelectorAll('.srf-upsell__item.is-open');
        for (var i = 0; i < others.length; i++) if (others[i] !== item) {
          others[i].classList.remove('is-open');
          var ob = others[i].querySelector('[data-srf-open]');
          if (ob) { ob.textContent = TXT_OPEN; ob.setAttribute('aria-expanded', 'false'); }
        }
        var willOpen = !item.classList.contains('is-open');
        item.classList.toggle('is-open', willOpen);
        t.textContent = willOpen ? TXT_CLOSE : TXT_OPEN;
        t.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        if (willOpen) buildPanel(item);
        return;
      }
      if (t.hasAttribute('data-srf-size')) {
        var panel = item.querySelector('.srf-upsell__panel');
        panel.setAttribute('data-size', t.getAttribute('data-srf-size'));
        var sel = panel.querySelector('[data-srf-color]');
        if (sel) panel.setAttribute('data-color', sel.value);
        buildPanel(item);
        return;
      }
      if (t.hasAttribute('data-srf-add-panel')) {
        var v = selectedVariant(item);
        if (v) addVariant(v.id, t);
        return;
      }
      var s2 = item.querySelector('[data-srf-simple]');
      addVariant(s2 ? s2.value : t.getAttribute('data-v'), t);
    });
    setInterval(function() { renderIn('drawer'); if (IS_CART_PAGE) renderIn('page'); }, 700);
  })();
